import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13b198a6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=13b198a6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b198a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13b198a6')) {
      api.createRecord('13b198a6', component.options)
    } else {
      api.reload('13b198a6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=13b198a6&scoped=true", function () {
      api.rerender('13b198a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PixCPF/index.vue"
export default component.exports